<template>
    <div class="application-supplement-form">
        <page-reg-link
            supplement-mode
            :supplement-data="applicationData"
            @supplement-submitted="$emit('submitted')"
        />
    </div>
</template>

<script>
import PageRegLink from './PageRegLink.vue';

export default {
    name: 'ApplicationSupplementForm',
    components: { PageRegLink },
    props: {
        applicationData: {
            type: Object,
            default: null,
        },
    },
};
</script>

<style scoped>
.application-supplement-form {
    margin-top: 12px;
    width: 100%;
}
</style>
